(function () {

  var drawer = document.querySelector('[data-ml-cart]');
  if (!drawer) return;

  var routesRoot =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  var itemsContainer =
    drawer.querySelector('[data-ml-cart-items]');

  var emptyState =
    drawer.querySelector('[data-ml-cart-empty]');

  var footer =
    drawer.querySelector('[data-ml-cart-footer]');

  var countElement =
    drawer.querySelector('[data-ml-cart-count]');

  var progress =
    drawer.querySelector('[data-ml-cart-progress]');

  var progressTitle =
    drawer.querySelector('[data-ml-cart-progress-title]');

  var progressSubtitle =
    drawer.querySelector('[data-ml-cart-progress-subtitle]');

  var progressFill =
    drawer.querySelector('[data-ml-cart-progress-fill]');

  var discountPill =
    drawer.querySelector('[data-ml-cart-discount-pill]');

  var nextSaving =
    drawer.querySelector('[data-ml-cart-next-saving]');

  var subtotalElement =
    drawer.querySelector('[data-ml-cart-subtotal]');

  var licenseRow =
    drawer.querySelector('[data-ml-cart-license-row]');

  var licenseTotalElement =
    drawer.querySelector('[data-ml-cart-license-total]');

  var savingsRow =
    drawer.querySelector('[data-ml-cart-savings-row]');

  var savingsElement =
    drawer.querySelector('[data-ml-cart-savings]');

  var totalElement =
    drawer.querySelector('[data-ml-cart-total]');

  var addMoreButton =
    drawer.querySelector('[data-ml-cart-add-more]');

  var checkoutButton =
    drawer.querySelector('[data-ml-cart-checkout]');

  var progressSteps =
    Array.prototype.slice.call(
      drawer.querySelectorAll('[data-ml-cart-tier]')
    );

  var currency =
    drawer.dataset.currency || 'USD';

  var browseUrl =
    drawer.dataset.browseUrl || '/collections/all';

  var updating = false;
  var lastFocusedElement = null;

  var tiers = [
    { qty: 2, discount: 10 },
    { qty: 3, discount: 15 },
    { qty: 4, discount: 20 },
    { qty: 5, discount: 25 },
    { qty: 6, discount: 30 }
  ];


  /* =========================================================
     HELPERS
     ========================================================= */

  function escapeHtml(value) {

    return String(
      value == null ? '' : value
    )
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  }


  function money(cents) {

    cents =
      parseInt(cents, 10) || 0;

    try {

      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-US',
        {
          style: 'currency',
          currency: currency
        }
      ).format(cents / 100);

    } catch (error) {

      return (cents / 100).toFixed(2);

    }

  }


  function normalizeProperties(item) {

    if (
      !item ||
      !item.properties ||
      typeof item.properties !== 'object'
    ) {
      return {};
    }

    return item.properties;

  }


  /* =========================================================
     LICENSE CONFIG
     ========================================================= */

  function licenseConfigs() {

    return {

      personal: {
        value: 'personal',
        label: 'Personal',
        variantId: 0,
        price: 0,
        description:
          'For private gatherings with friends or family. Birthdays, family nights and private parties.'
      },

      nonprofit: {
        value: 'nonprofit',
        label: 'Non-Profit',

        variantId:
          parseInt(
            drawer.dataset.licenseNonprofitVariant,
            10
          ) || 0,

        price:
          parseInt(
            drawer.dataset.licenseNonprofitPrice,
            10
          ) || 0,

        description:
          'For charities, churches, community groups and registered non-profits. For non-commercial activities and community events.'
      },

      business: {
        value: 'business',
        label: 'Business / Organization',

        variantId:
          parseInt(
            drawer.dataset.licenseBusinessVariant,
            10
          ) || 0,

        price:
          parseInt(
            drawer.dataset.licenseBusinessPrice,
            10
          ) || 0,

        description:
          'For internal use by companies, schools, institutions and teams. Perfect for team building, employee events and organized activities.'
      },

      forprofit: {
        value: 'forprofit',
        label: 'For-Profit',

        variantId:
          parseInt(
            drawer.dataset.licenseForprofitVariant,
            10
          ) || 0,

        price:
          parseInt(
            drawer.dataset.licenseForprofitPrice,
            10
          ) || 0,

        description:
          'For paid events, commercial activities or services where participation generates revenue. For venues, event organizers and professional use.'
      }

    };

  }


  function licenseValueFromLabel(label) {

    var normalized =
      String(label || '')
        .trim()
        .toLowerCase();

    if (normalized === 'non-profit') {
      return 'nonprofit';
    }

    if (
      normalized === 'business / organization' ||
      normalized === 'business/organization'
    ) {
      return 'business';
    }

    if (normalized === 'for-profit') {
      return 'forprofit';
    }

    return 'personal';

  }


  /* =========================================================
     PRODUCT TYPES
     ========================================================= */

  function isLicenseItem(item) {

    var handle =
      String(item.handle || '').toLowerCase();

    var type =
      String(item.product_type || '').toLowerCase();

    var properties =
      normalizeProperties(item);

    return (
      handle === 'non-profit-license' ||
      handle === 'business-organization-license' ||
      handle === 'for-profit-license' ||
      type === 'license add-on' ||
      !!properties['_License basis']
    );

  }


  function isPrintableGame(item) {

    if (isLicenseItem(item)) {
      return false;
    }

    var properties =
      normalizeProperties(item);

    if (
      properties['License'] ||
      String(
        properties['_ML bundle eligible'] || ''
      ).toLowerCase() === 'yes'
    ) {
      return true;
    }

    var type =
      String(item.product_type || '')
        .toLowerCase();

    var title =
      String(
        item.product_title ||
        item.title ||
        ''
      ).toLowerCase();

    if (
      type.indexOf('license') !== -1 ||
      type.indexOf('prop') !== -1 ||
      type.indexOf('board game') !== -1 ||
      type.indexOf('physical') !== -1
    ) {
      return false;
    }

    if (
      title.indexOf('printable') !== -1 ||
      title.indexOf('escape room') !== -1 ||
      title.indexOf('murder mystery') !== -1
    ) {
      return true;
    }

    if (
      type.indexOf('games') !== -1 ||
      type.indexOf('escape') !== -1 ||
      type.indexOf('murder') !== -1 ||
      type.indexOf('jeux') !== -1
    ) {
      return true;
    }

    return false;

  }


  function gameItems(cart) {

    return cart.items.filter(
      isPrintableGame
    );

  }


  function licenseItems(cart) {

    return cart.items.filter(
      isLicenseItem
    );

  }


  function totalQuantity(items) {

    return items.reduce(
      function (total, item) {

        return total +
          (
            parseInt(
              item.quantity,
              10
            ) || 0
          );

      },
      0
    );

  }


  function gameCount(cart) {

    return totalQuantity(
      gameItems(cart)
    );

  }


  /* =========================================================
     BUNDLE TIERS
     ========================================================= */

  function discountFor(quantity) {

    var discount = 0;

    tiers.forEach(
      function (tier) {

        if (quantity >= tier.qty) {
          discount = tier.discount;
        }

      }
    );

    return discount;

  }


  function nextTier(quantity) {

    for (
      var i = 0;
      i < tiers.length;
      i++
    ) {

      if (quantity < tiers[i].qty) {
        return tiers[i];
      }

    }

    return null;

  }


  function progressWidth(quantity) {

    if (quantity <= 2) {
      return 0;
    }

    return (
      (
        Math.min(quantity, 6) - 2
      ) /
      4
    ) * 80;

  }


  /* =========================================================
     SHOPIFY REQUESTS
     ========================================================= */

  async function fetchCart() {

    var response =
      await fetch(
        routesRoot + 'cart.js',
        {
          credentials: 'same-origin',
          cache: 'no-store',

          headers: {
            'Accept': 'application/json'
          }
        }
      );

    if (!response.ok) {
      throw new Error(
        'Could not load cart.'
      );
    }

    return response.json();

  }


  async function changeLineByNumber(
    line,
    quantity,
    properties
  ) {

    var payload = {

      line:
        parseInt(line, 10),

      quantity:
        Math.max(
          0,
          parseInt(quantity, 10) || 0
        )

    };

    if (properties) {
      payload.properties = properties;
    }

    var response =
      await fetch(
        routesRoot + 'cart/change.js',
        {
          method: 'POST',
          credentials: 'same-origin',

          headers: {
            'Content-Type':
              'application/json',

            'Accept':
              'application/json'
          },

          body:
            JSON.stringify(payload)
        }
      );

    if (!response.ok) {

      var message =
        'Could not update cart.';

      try {

        var errorData =
          await response.json();

        if (errorData.description) {
          message =
            errorData.description;
        }

      } catch (error) {}

      throw new Error(message);

    }

    return response.json();

  }


  async function updateLines(updates) {

    var response =
      await fetch(
        routesRoot + 'cart/update.js',
        {
          method: 'POST',
          credentials: 'same-origin',

          headers: {
            'Content-Type':
              'application/json',

            'Accept':
              'application/json'
          },

          body:
            JSON.stringify({
              updates: updates
            })
        }
      );

    if (!response.ok) {

      throw new Error(
        'Could not update cart.'
      );

    }

    return response.json();

  }


  async function addItems(items) {

    if (!items.length) {
      return fetchCart();
    }

    var response =
      await fetch(
        routesRoot + 'cart/add.js',
        {
          method: 'POST',
          credentials: 'same-origin',

          headers: {
            'Content-Type':
              'application/json',

            'Accept':
              'application/json'
          },

          body:
            JSON.stringify({
              items: items
            })
        }
      );

    if (!response.ok) {

      var message =
        'Could not add license product.';

      try {

        var errorData =
          await response.json();

        if (errorData.description) {
          message =
            errorData.description;
        }

      } catch (error) {}

      throw new Error(message);

    }

    return fetchCart();

  }


  /* =========================================================
     FRESH LINE RESOLUTION
     ========================================================= */

  function editorIdentity(editor) {

    return {

      key:
        String(
          editor.dataset.key || ''
        ),

      variantId:
        parseInt(
          editor.dataset.variantId,
          10
        ) || 0,

      productId:
        parseInt(
          editor.dataset.productId,
          10
        ) || 0,

      currentLicense:
        String(
          editor.dataset.currentLicense ||
          'personal'
        ),

      currentOrg:
        String(
          editor.dataset.currentOrg || ''
        ).trim()

    };

  }


  function resolveFreshGameLine(
    cart,
    identity
  ) {

    /*
     * First try the exact key.
     */

    for (
      var i = 0;
      i < cart.items.length;
      i++
    ) {

      var exactItem =
        cart.items[i];

      if (
        exactItem.key ===
          identity.key &&
        isPrintableGame(exactItem)
      ) {

        return {
          item: exactItem,
          line: i + 1
        };

      }

    }


    /*
     * The key can change when properties or
     * automatic discounts change. Fall back
     * to the stable variant/product IDs.
     */

    var candidates = [];

    cart.items.forEach(
      function (item, index) {

        if (!isPrintableGame(item)) {
          return;
        }

        var sameVariant =
          !identity.variantId ||
          parseInt(
            item.variant_id,
            10
          ) ===
          identity.variantId;

        var sameProduct =
          !identity.productId ||
          parseInt(
            item.product_id,
            10
          ) ===
          identity.productId;

        if (
          sameVariant &&
          sameProduct
        ) {

          candidates.push({
            item: item,
            line: index + 1
          });

        }

      }
    );


    if (
      candidates.length === 1
    ) {

      return candidates[0];

    }


    /*
     * If the same variant exists more than once,
     * use the license that was active when this
     * editor was rendered.
     */

    for (
      var c = 0;
      c < candidates.length;
      c++
    ) {

      var properties =
        normalizeProperties(
          candidates[c].item
        );

      var currentLicense =
        licenseValueFromLabel(
          properties['License']
        );

      var currentOrg =
        String(
          properties['Licensed to'] || ''
        ).trim();

      if (
        currentLicense ===
          identity.currentLicense &&
        currentOrg.toLowerCase() ===
          identity.currentOrg.toLowerCase()
      ) {

        return candidates[c];

      }

    }


    return candidates.length
      ? candidates[0]
      : null;

  }


  /* =========================================================
     DEFAULT PERSONAL LICENSE
     ========================================================= */

  async function ensureDefaultLicenses(cart) {

    var currentCart = cart;

    /*
     * Use the current line number each time.
     * A property update can change item keys.
     */

    for (
      var safety = 0;
      safety < 50;
      safety++
    ) {

      var targetIndex = -1;

      for (
        var i = 0;
        i < currentCart.items.length;
        i++
      ) {

        var item =
          currentCart.items[i];

        if (!isPrintableGame(item)) {
          continue;
        }

        var properties =
          normalizeProperties(item);

        var missingLicense =
          !properties['License'] ||
          !String(
            properties['License']
          ).trim();

        var missingMarker =
          String(
            properties[
              '_ML bundle eligible'
            ] || ''
          ).toLowerCase() !== 'yes';

        if (
          missingLicense ||
          missingMarker
        ) {

          targetIndex = i;
          break;

        }

      }


      if (targetIndex === -1) {
        break;
      }


      var target =
        currentCart.items[
          targetIndex
        ];

      var newProperties =
        Object.assign(
          {},
          normalizeProperties(target)
        );


      if (
        !newProperties['License'] ||
        !String(
          newProperties['License']
        ).trim()
      ) {

        newProperties['License'] =
          'Personal';

      }


      newProperties[
        '_ML bundle eligible'
      ] =
        'yes';


      currentCart =
        await changeLineByNumber(
          targetIndex + 1,
          target.quantity,
          newProperties
        );

    }


    return currentCart;

  }


  /* =========================================================
     PAID LICENSE ADD-ONS
     ========================================================= */

  function desiredLicenseGroups(cart) {

    var configs =
      licenseConfigs();

    var groups = {};


    gameItems(cart).forEach(
      function (item) {

        var properties =
          normalizeProperties(item);

        var value =
          licenseValueFromLabel(
            properties['License']
          );


        if (value === 'personal') {
          return;
        }


        var config =
          configs[value];


        if (
          !config ||
          !config.variantId
        ) {

          throw new Error(
            'The ' +
            config.label +
            ' license product could not be found.'
          );

        }


        var organization =
          String(
            properties['Licensed to'] || ''
          ).trim();


        if (!organization) {
          return;
        }


        var groupKey =
          config.variantId +
          '|' +
          organization.toLowerCase();


        if (!groups[groupKey]) {

          groups[groupKey] = {

            variantId:
              config.variantId,

            label:
              config.label,

            organization:
              organization,

            quantity:
              0,

            titles:
              []

          };

        }


        groups[groupKey].quantity +=
          parseInt(
            item.quantity,
            10
          ) || 0;


        var title =
          item.product_title ||
          item.title ||
          'Game';


        if (
          groups[groupKey].titles.indexOf(
            title
          ) === -1
        ) {

          groups[groupKey].titles.push(
            title
          );

        }

      }
    );


    return Object.keys(groups)
      .map(
        function (key) {

          var group =
            groups[key];

          group.games =
            group.titles.join(', ');

          return group;

        }
      )
      .sort(
        function (a, b) {

          return (
            String(a.variantId) +
            a.organization
          ).localeCompare(
            String(b.variantId) +
            b.organization
          );

        }
      );

  }


  function currentLicenseGroups(cart) {

    return licenseItems(cart)
      .map(
        function (item) {

          var properties =
            normalizeProperties(item);

          return {

            variantId:
              parseInt(
                item.variant_id,
                10
              ) || 0,

            organization:
              String(
                properties[
                  '_Licensed to'
                ] || ''
              ).trim(),

            quantity:
              parseInt(
                item.quantity,
                10
              ) || 0,

            games:
              String(
                properties[
                  '_Licensed games'
                ] || ''
              ).trim()

          };

        }
      )
      .sort(
        function (a, b) {

          return (
            String(a.variantId) +
            a.organization
          ).localeCompare(
            String(b.variantId) +
            b.organization
          );

        }
      );

  }


  function sameLicensePlan(
    cart,
    desired
  ) {

    var current =
      currentLicenseGroups(cart);


    if (
      current.length !==
      desired.length
    ) {

      return false;

    }


    for (
      var i = 0;
      i < current.length;
      i++
    ) {

      if (
        current[i].variantId !==
          desired[i].variantId ||

        current[i].quantity !==
          desired[i].quantity ||

        current[i].organization.toLowerCase() !==
          desired[i].organization.toLowerCase() ||

        current[i].games !==
          desired[i].games
      ) {

        return false;

      }

    }


    return true;

  }


  async function syncLicenseAddons(cart) {

    var desired =
      desiredLicenseGroups(cart);


    if (
      sameLicensePlan(
        cart,
        desired
      )
    ) {

      return cart;

    }


    var existing =
      licenseItems(cart);


    if (existing.length) {

      var removals = {};

      existing.forEach(
        function (item) {

          removals[item.key] = 0;

        }
      );


      await updateLines(
        removals
      );


      cart =
        await fetchCart();

    }


    if (!desired.length) {
      return cart;
    }


    var items =
      desired.map(
        function (group) {

          return {

            id:
              group.variantId,

            quantity:
              group.quantity,

            properties: {

              '_License type':
                group.label,

              '_License basis':
                'Per game',

              '_Licensed games':
                group.games,

              '_Licensed to':
                group.organization

            }

          };

        }
      );


    await addItems(items);


    return fetchCart();

  }


  async function prepareCart(cart) {

    cart =
      await ensureDefaultLicenses(
        cart
      );

    cart =
      await syncLicenseAddons(
        cart
      );

    return cart;

  }


  /* =========================================================
     LICENSE UI
     ========================================================= */

  function licenseOptions(item) {

    var configs =
      licenseConfigs();

    var current =
      licenseValueFromLabel(
        normalizeProperties(item)[
          'License'
        ]
      );

    var options = [];


    options.push(
      '<option value="personal"' +
      (
        current === 'personal'
          ? ' selected'
          : ''
      ) +
      '>' +
        'Personal — Included' +
      '</option>'
    );


    [
      'nonprofit',
      'business',
      'forprofit'
    ].forEach(
      function (key) {

        var config =
          configs[key];

        if (!config.variantId) {
          return;
        }

        options.push(

          '<option value="' +
          key +
          '"' +

          (
            current === key
              ? ' selected'
              : ''
          ) +

          '>' +

            escapeHtml(
              config.label
            ) +

            ' — +' +

            escapeHtml(
              money(config.price)
            ) +

            ' / game' +

          '</option>'

        );

      }
    );


    return options.join('');

  }


  function renderLicenseEditor(item) {

  var properties =
    normalizeProperties(item);

  var value =
    licenseValueFromLabel(
      properties['License']
    );

  var config =
    licenseConfigs()[value] ||
    licenseConfigs().personal;

  var organization =
    String(
      properties['Licensed to'] || ''
    ).trim();

  var isPaid =
    value !== 'personal';

  var isApplied =
    isPaid && organization !== '';


  return (

    '<div' +

      ' class="mlcart-license-editor"' +

      ' data-ml-license-editor' +

      ' data-key="' +
        escapeHtml(item.key) +
      '"' +

      ' data-variant-id="' +
        escapeHtml(item.variant_id) +
      '"' +

      ' data-product-id="' +
        escapeHtml(item.product_id) +
      '"' +

      ' data-current-license="' +
        escapeHtml(value) +
      '"' +

      ' data-current-org="' +
        escapeHtml(organization) +
      '"' +

    '>' +


      '<div class="mlcart-license-row">' +

        '<label>License</label>' +

        '<div class="mlcart-license-select-wrap">' +

          '<select' +
            ' class="mlcart-license-select"' +
            ' data-ml-cart-license-select' +
          '>' +

            licenseOptions(item) +

          '</select>' +

          '<span class="mlcart-license-chevron">⌄</span>' +

        '</div>' +

      '</div>' +


      '<div' +
        ' class="mlcart-license-description"' +
        ' data-ml-license-description' +
      '>' +

        escapeHtml(
          config.description
        ) +

      '</div>' +


      '<div' +
        ' class="mlcart-license-org"' +
        ' data-ml-license-org-wrap' +

        (
          isPaid
            ? ''
            : ' hidden'
        ) +

      '>' +

        '<input' +
          ' type="text"' +
          ' data-ml-cart-license-org' +
          ' value="' +
            escapeHtml(organization) +
          '"' +
          ' placeholder="Organization name"' +
          ' autocomplete="organization"' +
        '>' +

        '<button' +
          ' type="button"' +
          ' class="mlcart-license-apply' +
          (
            isApplied
              ? ' is-applied'
              : ''
          ) +
          '"' +
          ' data-ml-cart-license-apply' +
        '>' +

          (
            isApplied
              ? 'APPLIED ✓'
              : 'APPLY'
          ) +

        '</button>' +

        '<span' +
          ' class="mlcart-license-error"' +
          ' data-ml-license-error' +
          ' hidden' +
        '>' +
          'Please enter the organization name.' +
        '</span>' +

      '</div>' +


      (
        isApplied
          ? (
              '<div class="mlcart-license-saved">' +
                '<span>✓</span>' +
                '<span>Licensed to: <strong>' +
                  escapeHtml(organization) +
                '</strong></span>' +
              '</div>'
            )
          : ''
      ) +

    '</div>'

  );

}


  /* =========================================================
     OTHER ITEM PROPERTIES
     ========================================================= */

  function visibleProperties(item) {

    var properties =
      normalizeProperties(item);


    return Object.keys(properties)
      .filter(
        function (key) {

          var value =
            properties[key];

          return (
            key.charAt(0) !== '_' &&
            key !== 'License' &&
            key !== 'Licensed to' &&
            value != null &&
            String(value).trim() !== ''
          );

        }
      )
      .map(
        function (key) {

          return {
            key: key,
            value:
              String(
                properties[key]
              )
          };

        }
      );

  }


  function renderProperties(item) {

    var properties =
      visibleProperties(item);


    if (!properties.length) {
      return '';
    }


    return (
      '<div class="mlcart-properties">' +

      properties.map(
        function (property) {

          return (

            '<div class="mlcart-property">' +

              '<strong>' +
                escapeHtml(
                  property.key
                ) +
              ':</strong> ' +

              escapeHtml(
                property.value
              ) +

            '</div>'

          );

        }
      ).join('') +

      '</div>'
    );

  }


  /* =========================================================
     PRICES + PRODUCTS
     ========================================================= */

  function renderPrice(item) {

    var original =
      parseInt(
        item.original_line_price,
        10
      ) || 0;

    var finalPrice =
      parseInt(
        item.final_line_price,
        10
      );


    if (isNaN(finalPrice)) {

      finalPrice =
        parseInt(
          item.line_price,
          10
        ) || 0;

    }


    if (finalPrice < original) {

      return (

        '<div class="mlcart-item-price">' +

          '<del>' +
            escapeHtml(
              money(original)
            ) +
          '</del>' +

          '<strong>' +
            escapeHtml(
              money(finalPrice)
            ) +
          '</strong>' +

        '</div>'

      );

    }


    return (

      '<div class="mlcart-item-price">' +

        '<strong>' +
          escapeHtml(
            money(finalPrice)
          ) +
        '</strong>' +

      '</div>'

    );

  }


  function renderItem(item) {

    var image =
      item.image ||
      (
        item.featured_image &&
        item.featured_image.url
      ) ||
      '';

    var title =
      item.product_title ||
      item.title ||
      'Product';

    var url =
      item.url || '#';

    var variantTitle =
      item.variant_title &&
      item.variant_title !==
        'Default Title'
        ? item.variant_title
        : '';


    return (

      '<article class="mlcart-item">' +


        (
          image
            ? (

                '<a' +
                  ' class="mlcart-item-image"' +
                  ' href="' +
                    escapeHtml(url) +
                  '"' +
                '>' +

                  '<img' +
                    ' src="' +
                      escapeHtml(image) +
                    '"' +
                    ' alt="' +
                      escapeHtml(title) +
                    '"' +
                  '>' +

                '</a>'

              )
            : (
                '<div class="mlcart-item-image"></div>'
              )
        ) +


        '<div class="mlcart-item-main">' +


          '<a' +
            ' class="mlcart-item-title"' +
            ' href="' +
              escapeHtml(url) +
            '"' +
          '>' +

            escapeHtml(title) +

          '</a>' +


          (
            variantTitle
              ? (

                  '<div class="mlcart-item-variant">' +
                    escapeHtml(
                      variantTitle
                    ) +
                  '</div>'

                )
              : ''
          ) +


          renderProperties(item) +

          renderLicenseEditor(item) +


          '<div class="mlcart-item-controls">' +

            '<div class="mlcart-quantity">' +

              '<button' +
                ' type="button"' +
                ' class="mlcart-qty-button"' +
                ' data-ml-cart-quantity="-1"' +
                ' data-key="' +
                  escapeHtml(item.key) +
                '"' +
                ' data-variant-id="' +
                  escapeHtml(item.variant_id) +
                '"' +
                ' data-product-id="' +
                  escapeHtml(item.product_id) +
                '"' +
                ' data-current="' +
                  escapeHtml(item.quantity) +
                '"' +
              '>' +
                '−' +
              '</button>' +

              '<span class="mlcart-quantity-value">' +
                escapeHtml(item.quantity) +
              '</span>' +

              '<button' +
                ' type="button"' +
                ' class="mlcart-qty-button"' +
                ' data-ml-cart-quantity="1"' +
                ' data-key="' +
                  escapeHtml(item.key) +
                '"' +
                ' data-variant-id="' +
                  escapeHtml(item.variant_id) +
                '"' +
                ' data-product-id="' +
                  escapeHtml(item.product_id) +
                '"' +
                ' data-current="' +
                  escapeHtml(item.quantity) +
                '"' +
              '>' +
                '+' +
              '</button>' +

            '</div>' +


            '<button' +
              ' type="button"' +
              ' class="mlcart-remove"' +
              ' data-ml-cart-remove' +
              ' data-key="' +
                escapeHtml(item.key) +
              '"' +
              ' data-variant-id="' +
                escapeHtml(item.variant_id) +
              '"' +
              ' data-product-id="' +
                escapeHtml(item.product_id) +
              '"' +
            '>' +
              'Remove' +
            '</button>' +

          '</div>' +


        '</div>' +


        renderPrice(item) +


      '</article>'

    );

  }


  /* =========================================================
     PROGRESS
     ========================================================= */

  function updateProgress(cart) {

    var quantity =
      gameCount(cart);


    if (quantity <= 0) {

      progress.hidden = true;
      return;

    }


    progress.hidden = false;


    var discount =
      discountFor(quantity);

    var next =
      nextTier(quantity);


    if (discount > 0) {

      discountPill.hidden = false;

      discountPill.textContent =
        discount +
        '% OFF';

    } else {

      discountPill.hidden = true;

    }


    if (next) {

      var needed =
        next.qty -
        quantity;


      if (discount > 0) {

        progressTitle.textContent =
          discount +
          '% OFF unlocked';

        progressSubtitle.textContent =
          'Add ' +
          needed +
          (
            needed === 1
              ? ' more game'
              : ' more games'
          ) +
          ' to unlock ' +
          next.discount +
          '% OFF.';

      } else {

        progressTitle.textContent =
          'Add ' +
          needed +
          (
            needed === 1
              ? ' more game'
              : ' more games'
          ) +
          ' to save ' +
          next.discount +
          '%';

        progressSubtitle.textContent =
          'Bundle savings start with 2 games.';

      }


      nextSaving.textContent =
        'Add ' +
        needed +
        (
          needed === 1
            ? ' more game for '
            : ' more games for '
        ) +
        next.discount +
        '% OFF';

    } else {

      progressTitle.textContent =
        'Maximum 30% OFF unlocked';

      progressSubtitle.textContent =
        'You reached the highest bundle discount.';

      nextSaving.textContent =
        'Maximum 30% OFF unlocked';

    }


    progressFill.style.width =
      progressWidth(quantity) +
      '%';


    progressSteps.forEach(
      function (step) {

        var tierQty =
          parseInt(
            step.dataset.mlCartTier,
            10
          );

        step.classList.toggle(
          'is-active',
          quantity >= tierQty
        );

        step.classList.toggle(
          'is-next',
          next &&
          next.qty === tierQty
        );

      }
    );

  }


  /* =========================================================
     HEADER CART COUNT
     ========================================================= */

  function updateHeaderBadge(count) {

    [
      '[data-cart-count]',
      '.cart-count',
      '.sf-cart-count',
      '.m-cart-count-bubble'
    ].forEach(
      function (selector) {

        document
          .querySelectorAll(selector)
          .forEach(
            function (element) {

              if (
                drawer.contains(element)
              ) {
                return;
              }

              var target =
                element.children.length
                  ? (
                      element.querySelector(
                        'span'
                      ) ||
                      element
                    )
                  : element;

              target.textContent =
                count;

            }
          );

      }
    );

  }


  /* =========================================================
     RENDER CART
     ========================================================= */

  function renderCart(cart) {

    if (cart.currency) {
      currency = cart.currency;
    }


    var games =
      gameItems(cart);

    var count =
      totalQuantity(games);


    updateHeaderBadge(count);


    countElement.textContent =
      count +
      (
        count === 1
          ? ' game'
          : ' games'
      );


    if (!games.length) {

      itemsContainer.innerHTML = '';

      emptyState.hidden = false;

      footer.hidden = true;

      progress.hidden = true;

      return;

    }


    emptyState.hidden = true;

    footer.hidden = false;


    itemsContainer.innerHTML =
      games
        .map(renderItem)
        .join('');


    updateProgress(cart);


    var gameSubtotal =
      games.reduce(
        function (total, item) {

          return total +
            (
              parseInt(
                item.original_line_price,
                10
              ) || 0
            );

        },
        0
      );


    var gameSavings =
      games.reduce(
        function (total, item) {

          var original =
            parseInt(
              item.original_line_price,
              10
            ) || 0;

          var finalPrice =
            parseInt(
              item.final_line_price,
              10
            );

          if (isNaN(finalPrice)) {

            finalPrice =
              parseInt(
                item.line_price,
                10
              ) || 0;

          }

          return total +
            Math.max(
              0,
              original - finalPrice
            );

        },
        0
      );


    var licenses =
      licenseItems(cart);


    var licenseTotal =
      licenses.reduce(
        function (total, item) {

          var price =
            parseInt(
              item.final_line_price,
              10
            );

          if (isNaN(price)) {

            price =
              parseInt(
                item.line_price,
                10
              ) || 0;

          }

          return total + price;

        },
        0
      );


    var total =
      parseInt(
        cart.total_price,
        10
      ) || 0;


    subtotalElement.textContent =
      money(gameSubtotal);


    if (licenseTotal > 0) {

      licenseRow.hidden = false;

      licenseTotalElement.textContent =
        money(licenseTotal);

    } else {

      licenseRow.hidden = true;

    }


    if (gameSavings > 0) {

      savingsRow.hidden = false;

      savingsElement.textContent =
        '−' +
        money(gameSavings);

    } else {

      savingsRow.hidden = true;

    }


    totalElement.textContent =
      money(total);

  }


  /* =========================================================
     LOADING
     ========================================================= */

  function setLoading(state) {

    updating = state;

    drawer.classList.toggle(
      'is-loading',
      state
    );

  }


  /* =========================================================
     REFRESH
     ========================================================= */

  async function refreshCart() {

    try {

      setLoading(true);


      var cart =
        await fetchCart();


      cart =
        await prepareCart(cart);


      cart =
        await fetchCart();


      renderCart(cart);


      return cart;

    } catch (error) {

      console.error(
        'MysteryLocks cart refresh error:',
        error
      );


      return null;

    } finally {

      setLoading(false);

    }

  }


  /* =========================================================
     QUANTITY / REMOVE
     ========================================================= */

  async function updateGameQuantity(
    identity,
    desiredQuantity
  ) {

    if (updating) {
      return;
    }


    try {

      setLoading(true);


      var cart =
        await fetchCart();


      var reference =
        resolveFreshGameLine(
          cart,
          identity
        );


      if (!reference) {

        throw new Error(
          'The cart item could not be found.'
        );

      }


      await changeLineByNumber(
        reference.line,
        desiredQuantity
      );


      cart =
        await fetchCart();


      cart =
        await prepareCart(cart);


      cart =
        await fetchCart();


      renderCart(cart);

    } catch (error) {

      console.error(
        'MysteryLocks cart update error:',
        error
      );


      await refreshCart();

    } finally {

      setLoading(false);

    }

  }


  /* =========================================================
     APPLY LICENSE
     ========================================================= */

  async function applyLicense(
    editor,
    value,
    organization
  ) {

    if (updating) {
      return;
    }


    var configs =
      licenseConfigs();

    var config =
      configs[value] ||
      configs.personal;


    var errorElement =
      editor.querySelector(
        '[data-ml-license-error]'
      );


    try {

      setLoading(true);


      var identity =
        editorIdentity(editor);


      var cart =
        await fetchCart();


      var reference =
        resolveFreshGameLine(
          cart,
          identity
        );


      if (!reference) {

        throw new Error(
          'The game could not be found in the cart. Please refresh the page and try again.'
        );

      }


      var properties =
        Object.assign(
          {},
          normalizeProperties(
            reference.item
          )
        );


      properties['License'] =
        config.label;


      properties[
        '_ML bundle eligible'
      ] =
        'yes';


      if (value === 'personal') {

        delete properties[
          'Licensed to'
        ];

      } else {

        organization =
          String(
            organization || ''
          ).trim();


        if (!organization) {

          throw new Error(
            'Please enter the organization name.'
          );

        }


        properties['Licensed to'] =
          organization;

      }


      /*
       * Use the freshly resolved LINE NUMBER,
       * not the old line-item key.
       */

      await changeLineByNumber(
        reference.line,
        reference.item.quantity,
        properties
      );


      /*
       * Read Shopify again because changing
       * properties can create a new line key.
       */

      cart =
        await fetchCart();


      cart =
        await syncLicenseAddons(
          cart
        );


      /*
       * Final clean read after the license
       * product has been added/updated.
       */

      cart =
        await fetchCart();


      renderCart(cart);


    } catch (error) {

      console.error(
        'MysteryLocks license update error:',
        error
      );


      if (errorElement) {

        errorElement.textContent =
          error.message ||
          'Could not update the license.';

        errorElement.hidden =
          false;

      }


    } finally {

      setLoading(false);

    }

  }


  /* =========================================================
     OPEN / CLOSE
     ========================================================= */

  function openDrawer() {

    lastFocusedElement =
      document.activeElement;


    drawer.classList.add(
      'is-open'
    );


    drawer.setAttribute(
      'aria-hidden',
      'false'
    );


    document.body.classList.add(
      'mlcart-open'
    );


    refreshCart();


    window.setTimeout(
      function () {

        var closeButton =
          drawer.querySelector(
            '.mlcart-close'
          );

        if (closeButton) {

          closeButton.focus({
            preventScroll: true
          });

        }

      },
      220
    );

  }


  function closeDrawer() {

    drawer.classList.remove(
      'is-open'
    );


    drawer.setAttribute(
      'aria-hidden',
      'true'
    );


    document.body.classList.remove(
      'mlcart-open'
    );


    if (
      lastFocusedElement &&
      typeof lastFocusedElement.focus ===
        'function'
    ) {

      lastFocusedElement.focus({
        preventScroll: true
      });

    }

  }


  /* =========================================================
     LICENSE SELECT CHANGE
     ========================================================= */

  drawer.addEventListener(
    'change',
    function (event) {

      var select =
        event.target.closest(
          '[data-ml-cart-license-select]'
        );


      if (!select) {
        return;
      }


      var editor =
        select.closest(
          '[data-ml-license-editor]'
        );


      var config =
        licenseConfigs()[
          select.value
        ] ||
        licenseConfigs().personal;


      var description =
        editor.querySelector(
          '[data-ml-license-description]'
        );


      var orgWrap =
        editor.querySelector(
          '[data-ml-license-org-wrap]'
        );


      var orgInput =
        editor.querySelector(
          '[data-ml-cart-license-org]'
        );


      var error =
        editor.querySelector(
          '[data-ml-license-error]'
        );


      if (description) {

        description.textContent =
          config.description;

      }


      if (error) {
        error.hidden = true;
      }


      var applyButton =
  editor.querySelector(
    '[data-ml-cart-license-apply]'
  );

var savedMessage =
  editor.querySelector(
    '.mlcart-license-saved'
  );

if (applyButton) {

  applyButton.textContent =
    'APPLY';

  applyButton.classList.remove(
    'is-applied'
  );

}

if (savedMessage) {

  savedMessage.remove();

}
if (
        select.value ===
        'personal'
      ) {

        orgWrap.hidden = true;


        applyLicense(
          editor,
          'personal',
          ''
        );


        return;

      }


      orgWrap.hidden = false;


      if (orgInput) {
        orgInput.focus();
      }

    }
  );


  /* =========================================================
     CLICKS
     ========================================================= */

  drawer.addEventListener(
    'click',
    function (event) {

      var close =
        event.target.closest(
          '[data-ml-cart-close]'
        );


      if (close) {

        closeDrawer();

        return;

      }


      var quantityButton =
        event.target.closest(
          '[data-ml-cart-quantity]'
        );


      if (quantityButton) {

        var difference =
          parseInt(
            quantityButton.dataset.mlCartQuantity,
            10
          ) || 0;


        var current =
          parseInt(
            quantityButton.dataset.current,
            10
          ) || 0;


        updateGameQuantity(
          {
            key:
              quantityButton.dataset.key,

            variantId:
              parseInt(
                quantityButton.dataset.variantId,
                10
              ) || 0,

            productId:
              parseInt(
                quantityButton.dataset.productId,
                10
              ) || 0,

            currentLicense:
              'personal',

            currentOrg:
              ''
          },

          current +
          difference
        );


        return;

      }


      var removeButton =
        event.target.closest(
          '[data-ml-cart-remove]'
        );


      if (removeButton) {

        var item =
          removeButton.closest(
            '.mlcart-item'
          );


        var editor =
          item
            ? item.querySelector(
                '[data-ml-license-editor]'
              )
            : null;


        var identity =
          editor
            ? editorIdentity(editor)
            : {
                key:
                  removeButton.dataset.key,

                variantId:
                  parseInt(
                    removeButton.dataset.variantId,
                    10
                  ) || 0,

                productId:
                  parseInt(
                    removeButton.dataset.productId,
                    10
                  ) || 0,

                currentLicense:
                  'personal',

                currentOrg:
                  ''
              };


        updateGameQuantity(
          identity,
          0
        );


        return;

      }


      var applyButton =
        event.target.closest(
          '[data-ml-cart-license-apply]'
        );


      if (applyButton) {

        var editor =
          applyButton.closest(
            '[data-ml-license-editor]'
          );


        var select =
          editor.querySelector(
            '[data-ml-cart-license-select]'
          );


        var orgInput =
          editor.querySelector(
            '[data-ml-cart-license-org]'
          );


        var error =
          editor.querySelector(
            '[data-ml-license-error]'
          );


        var organization =
          orgInput
            ? orgInput.value.trim()
            : '';


        if (
          select.value !==
            'personal' &&
          !organization
        ) {

          error.textContent =
            'Please enter the organization name.';

          error.hidden = false;

          orgInput.focus();

          return;

        }


        error.hidden = true;


        applyLicense(
          editor,
          select.value,
          organization
        );

      }

    }
  );


  /* =========================================================
     ENTER IN ORGANIZATION FIELD
     ========================================================= */

  drawer.addEventListener(
    'keydown',
    function (event) {

      var input =
        event.target.closest(
          '[data-ml-cart-license-org]'
        );


      if (
        !input ||
        event.key !== 'Enter'
      ) {
        return;
      }


      event.preventDefault();


      var editor =
        input.closest(
          '[data-ml-license-editor]'
        );


      var button =
        editor.querySelector(
          '[data-ml-cart-license-apply]'
        );


      if (button) {
        button.click();
      }

    }
  );


  /* =========================================================
     ADD ANOTHER GAME
     ========================================================= */

  addMoreButton.addEventListener(
    'click',
    function () {

      closeDrawer();


      var bundleButton =
        document.querySelector(
          '[data-mlpb-root] #mlpbAddGame'
        );


      if (bundleButton) {

        window.setTimeout(
          function () {

            bundleButton.click();

          },
          220
        );


        return;

      }


      window.location.href =
        browseUrl;

    }
  );


  /* =========================================================
     CHECKOUT
     ========================================================= */

  checkoutButton.addEventListener(
    'click',
    function () {

      window.location.href =
        routesRoot +
        'checkout';

    }
  );


  /* =========================================================
     CUSTOM EVENTS
     ========================================================= */

  document.addEventListener(
    'ml:cart:open',
    openDrawer
  );


  document.addEventListener(
    'ml:cart:close',
    closeDrawer
  );


  document.addEventListener(
    'ml:cart:refresh',
    refreshCart
  );


  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        drawer.classList.contains(
          'is-open'
        )
      ) {

        closeDrawer();

      }

    }
  );


  /* =========================================================
     INTERCEPT /CART
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      var anchor =
        event.target.closest(
          'a[href]'
        );


      if (
        !anchor ||
        drawer.contains(anchor)
      ) {
        return;
      }


      try {

        var url =
          new URL(
            anchor.href,
            window.location.href
          );


        var path =
          url.pathname.replace(
            /\/+$/,
            ''
          );


        if (
          url.origin ===
            window.location.origin &&
          path === '/cart'
        ) {

          event.preventDefault();

          event.stopPropagation();

          openDrawer();

        }

      } catch (error) {}

    },
    true
  );


  /* =========================================================
     INITIAL REFRESH
     ========================================================= */

  refreshCart();

})();